import React, { useState, useEffect, useMemo } from 'react';
import { TextField, Button, Typography, Modal, Box, IconButton, FormControl } from '@mui/material';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { Close as CloseIcon } from '@mui/icons-material';
import { DatePicker } from '@mui/x-date-pickers';
import {useUser} from '../Context/UserContext'
import { postEvents, convertToBase64, getUserCompByUser } from '../controller.tsx'


import dayjs from 'dayjs';
import utc from "dayjs/plugin/utc";

const CreateEventModal = ({ isOpen , setIsOpen }) => {
    const { userID } = useUser();
    const [companyId, setCompanyId] = useState();

    useEffect(()=>{
        const loadCompany = async()=> {
            if(userID){
               const response = await getUserCompByUser(userID);
               setCompanyId(response?.companyId);
            }
        }
        loadCompany();
    },[userID]);

    dayjs.extend(utc);
    const today = useMemo(() => dayjs(), []);

    const [name, setName] = useState('');
    const [desc, setDesc] = useState('');
    const [location, setLocation] = useState('');
    const [address, setAddress] = useState(''); // todo: (add map verification) [autofill?]
    const [logo, setLogo] = useState(null); // todo: image picker (make sure this doesnt cause any issues with sizing and database)
    const [category, setCategory] = useState('');
    const [date, setDate] = useState(today);
    const [time, setTime] = useState(today);
    const [link, setLink] = useState('');

    const handleClose = () => setIsOpen(false);

    const handleFileChange = (event) => {
      if (event.target.files.length > 0) {
        setLogo(event.target.files[0]);
      }
    };

    const createEvent = async() => {
        const combinedDateTime = dayjs(date)
              .set("hour", time.hour())
              .set("minute", time.minute())
              .set("second", 0)
              .set("millisecond", 0);

        const timestampz = dayjs.utc(combinedDateTime).toISOString();
        const tempDate = date.format("YYYY-MM-DD");
        const tempTime = time.format("hh:mm A");
        const eToday = today.format('YYYY-MM-DD');
        const e64File = await convertToBase64(logo);

        await postEvents(name,desc,location,address,e64File,0,category,tempDate,1,eToday,timestampz,link,tempTime, companyId);
        handleClose();
      }

    return(
        <Modal open={isOpen} onClose={handleClose} sx={{overflow:'scroll',}}>
            <Box sx={{
                position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
                bgcolor: 'background.paper', p: 3, borderRadius: 2, boxShadow: 24, width: 400,
                maxWidth: '90%', '@media (max-width: 600px)': {
                  width: '90%',
                  padding: 2,
                }
            }}>
                <IconButton sx={{ position: 'absolute', right: 8, top: 8 }} onClick={handleClose}><CloseIcon/></IconButton>
                 <Typography id="resume" padding="5px 0px" variant="h4">Create event</Typography>
                 <FormControl fullWidth>
                     <TextField variant="filled" fullWidth required id="eName" label="Event name" margin="dense"
                       value={name}
                       onChange={(event)=>setName(event.target.value)}
                     />
                     <TextField variant="filled" fullWidth required id="eDesc" label="Description" margin="dense" multiline rows={4}
                         value={desc}
                         onChange={(event)=>setDesc(event.target.value)}
                     />
                     <Button variant="contained" sx={{ mb: 1, backgroundColor:'#263238' }} component="label">
                         Photo
                         <input type="file" hidden onChange={handleFileChange}/>
                     </Button>
                     {logo && <p>Selected File: {logo.name}</p>}
                     <Select id="eCategory"
                         onChange={(event)=>setCategory(event.target.value)}
                         defaultValue='other'
                     >
                         <MenuItem value={'nightlife'}>Nightlife</MenuItem>
                         <MenuItem value={'races'}>Races</MenuItem>
                         <MenuItem value={'sports'}>Sports</MenuItem>
                         <MenuItem value={'other'}>Other</MenuItem>
                     </Select>
                     <TextField variant="filled" fullWidth required id="eVenue" label="Venue name" margin="dense"
                         value={location}
                         onChange={(event)=>setLocation(event.target.value)}
                     />
                     <TextField variant="filled" fullWidth required id="eAddress" label="Address" margin="dense"
                       value={address}
                       onChange={(event)=>setAddress(event.target.value)}
                     />
                     <DatePicker label="Date"
                         value={date}
                         onChange={(newDate) => setDate(newDate)}
                         sx={{
                             '@media (max-width: 600px)': {
                                 fontSize: '1rem',
                                 padding: '8px',
                             },
                       }}
                     />
                     <TimePicker label="Time"
                         value={time}
                         onChange={(newTime)=>setTime(newTime)}
                     />
                     <TextField variant="filled" fullWidth id="eLink" label="Other Links (optional)" margin="dense"
                       value={link}
                       onChange={(event)=>setLink(event.target.value)}
                     />
                     <Button variant="contained" sx={{ mb: 1, backgroundColor:'#263238' }} onClick={createEvent}>Submit</Button>
                 </FormControl>
            </Box>
        </Modal>
    )
}

export default CreateEventModal